import { useCallback, useContext, useMemo } from 'react';
import moment from 'moment';
import Input from '../../subComponents/input';
import { ButtonV2 } from '../../subComponents/button';
import { SearchOrdersContext } from '../../../contexts';
import { SEARCH } from '../../../constants/searchOrders.constant';
import './styles.scss';

export const DateFormat = 'YYYY-MM-DD';
export const MaxDate = moment().format(DateFormat);

export const SearchForm = ({
  searchOrdersAPI = {},

  searchOrders = async (body = SEARCH()) => ({}),
}) => {
  const { search, setSearch } = useContext(SearchOrdersContext);
  const { loading } = searchOrdersAPI;

  const dateError = useMemo(() => {
    const dE = new Map([
      ['startDate', {
        message: '',
      }]
    ]);
    dE.delete('startDate');

    if (search.startDate.length === 0) {
      return dE;
    }

    if (search.endDate.length === 0) {
      return dE;
    }

    if (moment(search.startDate).isBefore(search.endDate)) {
      return dE;
    }

    dE.set('startDate', {
      message: 'Invalid start & end dates'
    });

    return dE;
  }, [search.startDate, search.endDate]);

  const pickErrorMessage = useCallback((type = '') => {
    if (dateError.has(type)) {
      return dateError.get(type);
    }
    return { message: '' };
  }, [dateError]);

  const disabled = useMemo(() => {
    if (loading) {
      return true;
    }

    if (dateError.size > 0) {
      return true;
    }

    const itemState = `${search.orderId.length}-${search.startDate.length}-${search.endDate.length}-${search.firstName.length}-${search.lastName.length}`;
    if (itemState === '0-0-0-0-0') {
      return true;
    }

    return false;
  }, [search, dateError, loading]);

  const maxStartDate = useMemo(() => {
    if (search.endDate.length === 0) {
      return MaxDate;
    }

    return moment(search.endDate).format(DateFormat);
  }, [search.endDate]);

  const handleChange = (name, event) => {
    const _search = { ...search, [name]: event?.target?.value };
    setSearch(_search);
  };

  const handleSearchOrders = async () => {
    try {
      const { status } = await searchOrders(search);
      if (status !== 200) {
        // show error message if api failed
      }
    } catch (e) {

    }
  };

  return (
    <div className='flex flex-column gap-16'>
      <div className='flex flex-column gap-4 min-width-360'>
        <label className='input-label font-14 m-r-4'>Order #:</label>
        <Input name='orderId' label='' className='flex flex-fill' value={search.orderId} onChange={handleChange.bind(this, 'orderId')} />
      </div>

      <div className='flex flex-column gap-4 min-width-360'>
        <label className='input-label font-14'>Date range:</label>
        <div className='flex flex-fill gap-16'>
          <Input
            name='startDate'
            label=''
            type='date'
            value={search.startDate}
            max={maxStartDate}
            onChange={handleChange.bind(this, 'startDate')}
            message={pickErrorMessage('startDate').message}
            error={dateError.size > 0}
          />

          <div className='flex align-items-center height-30'>
            <Input
              name='endDate'
              label='through'
              type='date'
              value={search.endDate}
              max={MaxDate}
              onChange={handleChange.bind(this, 'endDate')}
              error={dateError.size > 0}
            />
          </div>
        </div>
      </div>

      <div className='flex flex-column gap-4 min-width-360'>
        <label className='input-label font-14 m-r-4'>Patient First Name:</label>
        <Input name='firstName' label='' className='flex flex-fill' value={search.firstName} onChange={handleChange.bind(this, 'firstName')} />
      </div>

      <div className='flex flex-column gap-4 min-width-360'>
        <label className='input-label font-14 m-r-4'>Patient Last Name:</label>
        <Input name='lastName' label='' className='flex flex-fill' value={search.lastName} onChange={handleChange.bind(this, 'lastName')} />
      </div>

      <div className='flex justify-content-flex-start min-width-360 max-width-360'>
        <ButtonV2
          label='Search'
          disabled={disabled}
          loading={loading}
          onClick={handleSearchOrders}
        />
      </div>
    </div>
  );
};

export default SearchForm;
